import { Button, Empty, Select, Table } from "antd";
import { useContext, useEffect, useState } from "react";
import { IndicationContext } from "../context/IndicationContext";
import { IIndication } from "../types";
import { v4 as uuidv4 } from "uuid";
import { PencilSimple } from "phosphor-react";
import { FormIndication } from "../components/Forms/FormIndication";
import { Modal } from "../components/Modal";

const { Option } = Select;

export const statusIndication = [
    { id: "pending", label: "Em análise" },
    { id: "waiting", label: "Em contato" },
    { id: "finished", label: "Convertido" },
    { id: "lost", label: "Não convertido" },
];

export function Indication() {
    const [open, setOpen] = useState(false);
    const [configModal, setConfigModal] = useState({
        title: "",
        content: <></>,
    });

    const { indications, getIndication, editIndication } =
        useContext(IndicationContext);

    useEffect(() => {
        getIndication();
    }, []);

    const dataSource = indications.map((i: IIndication) => {
        return { ...i, key: i.id_form_indication };
    });
    const columns = [
        // {
        //     key: "1",
        //     title: "ID",
        //     dataIndex: "id",
        // },

        // {
        //     key: "1",
        //     title: "Nome do escritório e/ou propriedade rural indicado",
        //     dataIndex: "company",
        // },
        {
            key: "2",
            title: "Nome do resp. indicado",
            dataIndex: "resp_name",
        },
        {
            key: "3",
            title: "Celular indicado",
            dataIndex: "phone",
        },
        {
            key: "4",
            title: "Origem da Indicação",
            dataIndex: "name_person",
        },
        {
            key: "5",
            title: "Data da indicação",
            dataIndex: "date",
            render: (text: any) => {
                let a;
                if (text) {
                    a = `${text.split("T")[0].split("-")[2]}/${
                        text.split("T")[0].split("-")[1]
                    }/${text.split("T")[0].split("-")[0]}
                    `;
                }

                return <>{a}</>;
            },
        },
        {
            key: "6",
            title: "Status",
            // dataIndex: "status",
            render: (record: any) => {
                let n = "";
                if (record.status !== null) {
                    n =
                        statusIndication[
                            statusIndication.findIndex(
                                (s: any) => s.id === record.status
                            )
                        ].label;
                }
                return <>{n}</>;
            },
        },
        {
            key: "7",
            title: "Ações",
            render: (record: any) => {
                return (
                    <Button type="link" onClick={() => handleEdit(record)}>
                        <PencilSimple size={18} />
                    </Button>
                );
            },
        },
    ];

    const handleEditStatus = (value: any) => {
        if (value) {
            let obj = {
                ...value,
                attempts: null,
            };
            editIndication(obj);
        }
    };

    const handleEdit = (value: any) => {
        setConfigModal({
            title: "Editar Indicação",
            content: (
                <div>
                    <FormIndication setOpen={setOpen} cont={value} />
                </div>
            ),
        });
        setOpen(true);
    };

    async function expExcel() {
        const columns = Object.keys(dataSource[0]);
        console.log("Colunas original: ", columns);

        const columnMap: Record<string, string> = {
            resp_name: "Nome do resp. indicado",
            phone: "Celular indicado",
            name_person: "Origem da Indicação",
            date: "Data da indicação",
            status: "Status",
            city: "Cidade (indicado)",
            state: "Estado (indicado)",
            occupation: "Segmento de Atuação (indicado)",
            phone_person: "Celular origem",
            observation: "Observação",
        };

        const tableColumns = Object.keys(dataSource[0])
            .filter(col => columnMap[col])
            .map(col => ({ name: columnMap[col], key: col }));

        const rows = dataSource.map((row: any) =>
            tableColumns.map(col => {
                let value = row[col.key];

                if (col.key === "date" && value) {
                    const dt = `${value.split("T")[0].split("-")[2]}/${
                        value.split("T")[0].split("-")[1]
                    }/${value.split("T")[0].split("-")[0]}
                    `;

                    value = dt;
                }
                if (col.key === "status" && value) {
                    const s =
                        statusIndication[
                            statusIndication.findIndex(
                                (s: any) => s.id === value
                            )
                        ].label;
                    value = s;
                }

                return value;
            })
        );

        const ExcelJS = require("exceljs");
        const workbook = new ExcelJS.Workbook();
        workbook.creator = "GRANOS";
        workbook.created = new Date();
        const worksheet = workbook.addWorksheet("Planilha Indicacoes", {});

        //EDIÇÂO DAS PAGINAS DO EXCEL
        worksheet.addTable({
            name: "Tabela",
            ref: "A2",
            style: {
                theme: "TableStyleMedium22",
                showRowStripes: true,
            },
            headerRow: true,
            totalsRow: true,

            columns: tableColumns,
            rows: rows,
        });

        worksheet.headerFooter.oddFooter = "Page &P of &N";
        worksheet.headerFooter.addHeader = '&C&KCCCCCC&"Nunito"Granos';

        worksheet.columns.forEach((column: any, i: any) => {
            var maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, (cell: any) => {
                var columnLength = cell.value
                    ? cell.value.toString().length
                    : 10;
                if (columnLength > maxLength) {
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < 10 ? 10 : maxLength + 3;
        });

        workbook.xlsx.writeBuffer().then(function (data: any) {
            var blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
            });
            const FileSaver = require("file-saver");
            FileSaver.saveAs(blob, "Planilha Indicacoes.xlsx");
        });
    }

    return (
        <>
            <div
                style={{
                    width: "100%",
                    padding: "10px 50px 10px",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                    }}
                >
                    <h1> Indicações:</h1>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <Button
                            disabled={!dataSource || dataSource.length === 0}
                            onClick={() => expExcel()}
                        >
                            Exportar
                        </Button>
                    </div>
                </div>
                <div>
                    <Table
                        size="small"
                        columns={columns}
                        dataSource={dataSource}
                        locale={{
                            emptyText: (
                                <Empty
                                    description="Nenhuma indicação foi encontrada!"
                                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                                />
                            ),
                        }}
                        expandable={{
                            expandedRowRender: record => (
                                <div style={{ marginLeft: 50 }}>
                                    <strong>
                                        Outras informações da origem da
                                        indicação:
                                    </strong>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            marginBottom: "15px",
                                        }}
                                    >
                                        <div>
                                            Email origem: {record.email_person}
                                        </div>
                                        <div>
                                            Celular origem:{" "}
                                            {record.phone_person}
                                        </div>
                                    </div>
                                    <strong>
                                        Outras informações do indicado:
                                    </strong>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            marginBottom: "15px",
                                        }}
                                    >
                                        <div>
                                            Segmento de atuação:{" "}
                                            {record.occupation}
                                        </div>
                                        <div>
                                            Localização: {record.city},{" "}
                                            {record.state}
                                        </div>
                                    </div>
                                </div>
                            ),
                        }}
                    ></Table>{" "}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "right",
                            marginTop: "10px",
                            marginRight: "1vw",
                        }}
                    ></div>
                </div>
            </div>
            <Modal
                title={configModal.title}
                isVisible={open}
                width={600}
                setIsVisible={() => setOpen(false)}
            >
                {configModal.content}
            </Modal>
        </>
    );
}
